// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Suubi Community Platform - Custom Styles */

/* Sidebar styles */
.sidebar-active {
    border-left-width: 4px;
    border-color: hsl(var(--secondary));
    background-color: rgb(255 255 255 / 0.1);
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

/* Card hover effects */
.card-hover {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
    animation-duration: 300ms;
}
.card-hover:hover {
    --tw-translate-y: -0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

/* Chart tooltip styles */
.recharts-tooltip-wrapper {
    border-radius: 0.75rem !important;
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

/* Custom scrollbar */
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

::-webkit-scrollbar-track {
    border-radius: 9999px;
    background-color: hsl(var(--muted));
}

::-webkit-scrollbar-thumb {
    border-radius: 9999px;
    background-color: hsl(var(--muted-foreground) / 0.3);
}

::-webkit-scrollbar-thumb:hover {
    background-color: hsl(var(--muted-foreground) / 0.5);
}

/* Animations */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animate-fade-in {
    animation: fadeIn 0.3s ease-out;
}

/* Staggered animations for lists */
.stagger-1 { animation-delay: 0.05s; }
.stagger-2 { animation-delay: 0.1s; }
.stagger-3 { animation-delay: 0.15s; }
.stagger-4 { animation-delay: 0.2s; }

/* Table improvements */
.table-row-hover {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.table-row-hover:hover {
    background-color: hsl(var(--muted) / 0.5);
}
.dark .table-row-hover:hover { background-color: hsl(var(--muted) / 0.5); }

/* Button press effect */
.btn-press {
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.btn-press:active {
    --tw-scale-x: .95;
    --tw-scale-y: .95;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

/* Form focus styles */
.input-focus {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.input-focus:focus {
    border-color: hsl(var(--primary));
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
    --tw-ring-color: hsl(var(--primary) / 0.2);
}

/* Badge variants */
.badge-success {
    --tw-bg-opacity: 1;
    background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.dark .badge-success   { background-color: rgb(20 83 45 / 0.5); }

    .dark .badge-success    { color: rgb(134 239 172); }
.badge-success:is(.dark *) {
    background-color: rgb(20 83 45 / 0.3);
    --tw-text-opacity: 1;
    color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}

.badge-warning {
    --tw-bg-opacity: 1;
    background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}

.dark .badge-warning  { background-color: rgb(124 45 18 / 0.5); }


    .dark .badge-warning   { color: rgb(253 186 116); }

.badge-warning:is(.dark *) {
    background-color: rgb(124 45 18 / 0.3);
    --tw-text-opacity: 1;
    color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}

.badge-danger {
    --tw-bg-opacity: 1;
    background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}

.dark .badge-danger     { background-color: rgb(127 29 29 / 0.5); }


    .dark .badge-danger      { color: rgb(252 165 165); }

.badge-danger:is(.dark *) {
    background-color: rgb(127 29 29 / 0.3);
    --tw-text-opacity: 1;
    color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.badge-info {
    --tw-bg-opacity: 1;
    background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}

.dark .badge-info    { background-color: rgb(30 58 138 / 0.5); }


    .dark .badge-info     { color: rgb(147 197 253); }

.badge-info:is(.dark *) {
    background-color: rgb(30 58 138 / 0.3);
    --tw-text-opacity: 1;
    color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C,mBAAmB;AAEf;IAAA,sBAAqE;IAArE,mCAAqE;IAArE,wCAAqE;IAArE,gBAAqE;IAArE,oBAAqE;IAArE;AAAqE;;AAGzE,uBAAuB;AAEnB;IAAA,wBAAuE;IAAvE,wDAAuE;IAAvE,0BAAuE;IAAvE;AAAuE;AAAvE;IAAA,0BAAuE;IAAvE,+LAAuE;IAAvE,6EAAuE;IAAvE,iGAAuE;IAAvE;AAAuE;;AAG3E,yBAAyB;AAErB;IAAA,iCAA6B;IAA7B,0FAA6B;IAA7B,8GAA6B;IAA7B;AAA6B;;AAGjC,qBAAqB;AACrB;IACI,UAAU;IACV,WAAW;AACf;;AAGI;IAAA,qBAA4B;IAA5B;AAA4B;;AAI5B;IAAA,qBAAuE;IAAvE;AAAuE;;AAAvE;IAAA;AAAuE;;AAG3E,eAAe;AACf;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,+BAA+B;AACnC;;AAEA,mCAAmC;AACnC,aAAa,sBAAsB,EAAE;AACrC,aAAa,qBAAqB,EAAE;AACpC,aAAa,sBAAsB,EAAE;AACrC,aAAa,qBAAqB,EAAE;;AAEpC,uBAAuB;AAEnB;IAAA,+FAA0C;IAA1C,wDAA0C;IAA1C;AAA0C;AAA1C;IAAA;AAA0C;AAA1C,+BAAA,yCAA0C,EAAA;;AAG9C,wBAAwB;AAEpB;IAAA,8BAA2C;IAA3C,wDAA2C;IAA3C;AAA2C;AAA3C;IAAA,iBAA2C;IAA3C,iBAA2C;IAA3C;AAA2C;;AAG/C,sBAAsB;AAElB;IAAA,wBAA6E;IAA7E,wDAA6E;IAA7E;AAA6E;AAA7E;IAAA,iCAA6E;IAA7E,2GAA6E;IAA7E,yGAA6E;IAA7E,4FAA6E;IAA7E;AAA6E;;AAGjF,mBAAmB;AAEf;IAAA,kBAA2E;IAA3E,4DAA2E;IAA3E,oBAA2E;IAA3E;AAA2E;AAA3E,yBAAA,qCAA2E,EAAA;AAA3E;8BAAA,uBAA2E,EAAA;AAA3E;IAAA,qCAA2E;IAA3E,oBAA2E;IAA3E;AAA2E;;AAI3E;IAAA,kBAA+E;IAA/E,4DAA+E;IAA/E,oBAA+E;IAA/E;AAA+E;;AAA/E,wBAAA,sCAA+E,EAAA;;AAA/E;6BAAA,uBAA+E,EAAA;;AAA/E;IAAA,sCAA+E;IAA/E,oBAA+E;IAA/E;AAA+E;;AAI/E;IAAA,kBAAmE;IAAnE,4DAAmE;IAAnE,oBAAmE;IAAnE;AAAmE;;AAAnE,0BAAA,sCAAmE,EAAA;;AAAnE;+BAAA,uBAAmE,EAAA;;AAAnE;IAAA,sCAAmE;IAAnE,oBAAmE;IAAnE;AAAmE;;AAInE;IAAA,kBAAuE;IAAvE,4DAAuE;IAAvE,oBAAuE;IAAvE;AAAuE;;AAAvE,uBAAA,sCAAuE,EAAA;;AAAvE;4BAAA,uBAAuE,EAAA;;AAAvE;IAAA,sCAAuE;IAAvE,oBAAuE;IAAvE;AAAuE","sourcesContent":["/* Suubi Community Platform - Custom Styles */\n\n/* Sidebar styles */\n.sidebar-active {\n    @apply bg-white/10 text-white font-medium border-l-4 border-secondary;\n}\n\n/* Card hover effects */\n.card-hover {\n    @apply transition-all duration-300 hover:shadow-md hover:-translate-y-1;\n}\n\n/* Chart tooltip styles */\n.recharts-tooltip-wrapper {\n    @apply !rounded-xl !shadow-lg;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n::-webkit-scrollbar-track {\n    @apply bg-muted rounded-full;\n}\n\n::-webkit-scrollbar-thumb {\n    @apply bg-muted-foreground/30 rounded-full hover:bg-muted-foreground/50;\n}\n\n/* Animations */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.animate-fade-in {\n    animation: fadeIn 0.3s ease-out;\n}\n\n/* Staggered animations for lists */\n.stagger-1 { animation-delay: 0.05s; }\n.stagger-2 { animation-delay: 0.1s; }\n.stagger-3 { animation-delay: 0.15s; }\n.stagger-4 { animation-delay: 0.2s; }\n\n/* Table improvements */\n.table-row-hover {\n    @apply hover:bg-muted/50 transition-colors;\n}\n\n/* Button press effect */\n.btn-press {\n    @apply active:scale-95 transition-transform;\n}\n\n/* Form focus styles */\n.input-focus {\n    @apply focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all;\n}\n\n/* Badge variants */\n.badge-success {\n    @apply bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400;\n}\n\n.badge-warning {\n    @apply bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400;\n}\n\n.badge-danger {\n    @apply bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400;\n}\n\n.badge-info {\n    @apply bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
